import CommentsIcon from 'Assets/icons/comments.svg'
import { PanelHeader } from 'Components/common/TaskPanelHeader/TaskPanelHeader'
import styles from './Comments.module.less'
import { ClassItem, CommentsType } from 'Types/Classes.types'
import { CommentsBody } from 'Components/tasks/Comments/CommentsBody'

export type CommentsPropsType = {
    getClasses: () => ClassItem[]
    getComments: () => CommentsType[]
    updateAnnotationComment: (annotationId: string, comment: string) => void
    deleteAnnotationComment: (annotationId: string) => void
    getFocusedAnnotationId: () => string | null
    setFocusedAnnotationId: (id: string | null) => void
    onClickComment: (id: string) => void
    isReadOnly: () => boolean
}

export const Comments = (props: CommentsPropsType) => {
    return (
        <div className={styles['comments-container']} data-testid="comments-container">
            <PanelHeader title={'Comments'} actionButtons={[]} logo={CommentsIcon} />
            <CommentsBody
                classes={props.getClasses()}
                comments={props.getComments()}
                updateAnnotationComment={props.updateAnnotationComment}
                deleteAnnotationComment={props.deleteAnnotationComment}
                focusedAnnotationId={props.getFocusedAnnotationId()}
                setFocusedAnnotationId={props.setFocusedAnnotationId}
                onClickComment={props.onClickComment}
                isReadOnly={props.isReadOnly()}
            />
        </div>
    )
}
